module.exports = __webpack_public_path__ + "img/low-fat-green-bean-casserole.80a0c658.jpg";